import { createContext, useContext, useState } from "react";

const slidersSetters = [];
const SlideIndexContext = createContext();

export const SlideIndexProvider = ({ children }) => {
  const [slideIndex, setSlideIndex] = useState(0);

  slidersSetters.push(() => setSlideIndex);

  const setNewSlides = (colorName) => {
    const idx =
      colorName === "black"
        ? 0
        : colorName === "silver"
          ? 1
          : colorName === "gunmetal"
            ? 2
            : 3;
    setSlideIndex(idx);
  };

  return (
    <SlideIndexContext.Provider
      value={{ slideIndex: slideIndex, setSlideIndex: setNewSlides }}
    >
      {children}
    </SlideIndexContext.Provider>
  );
};

export const useSlideIndex = () => {
  const context = useContext(SlideIndexContext);
  if (!context) {
    throw new Error("useSlider must be used within a SliderProvider");
  }
  return context;
};
